var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"lang-selector-color-bullet",style:({
        backgroundColor: _vm.parsedHexColor
      })}),(_vm.option.title)?_c('div',[_c('div',[_vm._v(_vm._s(_vm.option.title))])]):_vm._e()]),(_vm.option.description)?_c('div',{staticClass:"f6"},[_vm._v(" "+_vm._s(_vm.option.description)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }